export const COLLECTOR_PERMISSIONS = {
  FLEET_CREATE: "collector_fleets:create",
  FLEET_READ: "collector_fleets:read",
  FLEET_EDIT: "collector_fleets:edit",
  FLEET_DELETE: "collector_fleets:delete",
  FLEET_INSTANCE_ASSIGN: "collector_fleets:assign_instance",
  FLEET_INSTANCE_DELETE: "collector_fleets:delete_instance",
  SOURCE_CREATE: "collector_fleets:source_create",
  SOURCE_EDIT: "collector_fleets:source_edit",
  SOURCE_DELETE: "collector_fleets:source_delete",
  ENROLL_TOKEN_CREATE: "collector_enrollment_tokens:create",
  ENROLL_TOKEN_READ: "collector_enrollment_tokens:read",
  ENROLL_TOKEN_DELETE: "collector_enrollment_tokens:delete",
  CONFIGURATION_READ: "collectors_config:read",
  CONFIGURATION_EDIT: "collectors_config:edit",
  ACTIVITIES_READ: "collector_activities:read"
};
export const scoped = (permission, entityId) => `${permission}:${entityId}`;
